/* Exotiks — selecteur de format (v176)
   Intercepte le clic sur "Ajouter" des cartes produit multi-variantes et propose
   le grammage au lieu d'ajouter la premiere variante. */
(function () {
  if (window.__exoFormatSheet) return;
  window.__exoFormatSheet = true;

  var sheet, ov, els = {};
  var state = { variants: [], sel: 0, url: '' };
  var cache = {};

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20ac';
  }

  function grams(title) {
    var m = String(title).replace(',', '.').match(/([\d.]+)\s*g\b/i);
    return m ? parseFloat(m[1]) : null;
  }

  function build() {
    ov = document.createElement('div');
    ov.className = 'exo-fs__ov';

    sheet = document.createElement('div');
    sheet.className = 'exo-fs';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML =
      '<button type="button" class="exo-fs__close" aria-label="Fermer">&times;</button>' +
      '<div class="exo-fs__grab"></div>' +
      '<div class="exo-fs__head">' +
        '<img class="exo-fs__thumb" alt="" width="46" height="46">' +
        '<div><div class="exo-fs__title"></div><div class="exo-fs__sub"></div></div>' +
      '</div>' +
      '<p class="exo-fs__label">Choisis ton format</p>' +
      '<div class="exo-fs__opts"></div>' +
      '<button type="button" class="exo-fs__cta"></button>' +
      '<p class="exo-fs__foot">Livraison offerte d\u00e8s 50 \u20ac \u00b7 colis neutre</p>' +
      '<a class="exo-fs__link" href="#">Voir la fiche compl\u00e8te</a>';

    document.body.appendChild(ov);
    document.body.appendChild(sheet);

    els.thumb = sheet.querySelector('.exo-fs__thumb');
    els.title = sheet.querySelector('.exo-fs__title');
    els.sub = sheet.querySelector('.exo-fs__sub');
    els.opts = sheet.querySelector('.exo-fs__opts');
    els.cta = sheet.querySelector('.exo-fs__cta');
    els.link = sheet.querySelector('.exo-fs__link');

    ov.addEventListener('click', close);
    sheet.querySelector('.exo-fs__close').addEventListener('click', close);
    els.cta.addEventListener('click', add);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function render() {
    var v = state.variants, base = null, i;
    for (i = 0; i < v.length; i++) {
      var g0 = grams(v[i].t);
      if (g0) { base = v[i].p / g0; break; }
    }

    var best = -1, bestPpg = Infinity;
    v.forEach(function (o, idx) {
      var g = grams(o.t);
      if (o.a && g) {
        var ppg = o.p / g;
        if (ppg < bestPpg) { bestPpg = ppg; best = idx; }
      }
    });
    if (best < 0) {
      for (i = 0; i < v.length; i++) { if (v[i].a) { best = i; break; } }
    }
    if (best < 0) best = 0;
    state.sel = best;

    var html = '';
    v.forEach(function (o, idx) {
      var g = grams(o.t);
      var ppg = g ? o.p / g : null;
      var eco = (ppg && base) ? Math.round((1 - ppg / base) * 100) : 0;
      html +=
        '<div class="exo-fs__wrap">' +
          (idx === best ? '<span class="exo-fs__best">Meilleur rapport</span>' : '') +
          '<button type="button" class="exo-fs__opt' + (idx === state.sel ? ' is-sel' : '') + '" data-i="' + idx + '"' + (o.a ? '' : ' disabled') + '>' +
            '<span class="exo-fs__radio"></span>' +
            '<span>' +
              '<span class="exo-fs__fmt"></span>' +
              '<span class="exo-fs__ppg">' + (ppg ? money(ppg) + ' / g' : '') + (o.a ? '' : (ppg ? ' \u00b7 \u00e9puis\u00e9' : '\u00c9puis\u00e9')) + '</span>' +
            '</span>' +
            '<span class="exo-fs__right">' +
              '<span class="exo-fs__price">' + money(o.p) + '</span>' +
              (eco > 0 && o.a ? '<span class="exo-fs__save">\u2212' + eco + ' % / g</span>' : '') +
            '</span>' +
          '</button>' +
        '</div>';
    });
    els.opts.innerHTML = html;

    els.opts.querySelectorAll('.exo-fs__opt').forEach(function (b) {
      var idx = parseInt(b.dataset.i, 10);
      b.querySelector('.exo-fs__fmt').textContent = v[idx].t;
      b.addEventListener('click', function () {
        if (b.hasAttribute('disabled')) return;
        state.sel = idx;
        els.opts.querySelectorAll('.exo-fs__opt').forEach(function (x) { x.classList.remove('is-sel'); });
        b.classList.add('is-sel');
        cta();
      });
    });
    cta();
  }

  function cta() {
    var o = state.variants[state.sel];
    els.cta.disabled = !o || !o.a;
    if (o && o.a) {
      els.cta.innerHTML = '<span>Ajouter au panier</span><span class="exo-fs__cta-sep">|</span><span class="exo-fs__cta-price"></span>';
      els.cta.querySelector('.exo-fs__cta-price').textContent = money(o.p);
    } else {
      els.cta.textContent = 'Format \u00e9puis\u00e9';
    }
  }

  function open(data) {
    state.variants = data.variants.map(function (x) {
      return { id: x.id, t: x.title, p: x.price, a: x.available };
    });
    state.url = data.url;

    els.title.textContent = data.title;
    els.sub.textContent = data.type || 'Choisir le format';
    els.link.href = data.url;
    if (data.image) { els.thumb.src = data.image; els.thumb.hidden = false; }
    else { els.thumb.hidden = true; }

    render();
    sheet.classList.add('is-open');
    ov.classList.add('is-open');
  }

  function close() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    ov.classList.remove('is-open');
  }

  function addDirect(id) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  }

  function add() {
    var o = state.variants[state.sel];
    if (!o || !o.a) return;
    els.cta.disabled = true;
    els.cta.textContent = 'Ajout en cours\u2026';

    addDirect(o.id)
      .then(function () {
        close();
        els.cta.disabled = false;
        cta();
      })
      .catch(function () {
        window.location.href = state.url;
      });
  }

  function productUrl(form) {
    var item = form.closest('.product-item') || form.parentElement;
    var link = item && item.querySelector('a[href*="/products/"]');
    if (!link) return null;
    return link.getAttribute('href').split('?')[0];
  }

  function load(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var d = {
          title: p.title,
          type: p.type,
          url: url,
          image: p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : null,
          variants: p.variants
        };
        cache[url] = d;
        return d;
      });
  }

  var DIRECT = '.product-item__cta-form--direct, .product-item__quick-form--direct';

  function handle(form) {
    var url = productUrl(form);
    if (!url) return false;
    if (!sheet) build();
    load(url).then(function (d) {
      if (!d.variants || d.variants.length < 2) {
        return addDirect(d.variants[0].id);
      }
      open(d);
    }).catch(function () {
      window.location.href = url;
    });
    return true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[type="submit"], [type="submit"]');
    if (!btn) return;
    var form = btn.closest(DIRECT);
    if (!form) return;
    if (handle(form)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches(DIRECT)) return;
    if (handle(form)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
